import { render, staticRenderFns } from "./CodeMirror.vue?vue&type=template&id=ca3464e8&"
import script from "./CodeMirror.vue?vue&type=script&lang=js&"
export * from "./CodeMirror.vue?vue&type=script&lang=js&"
import style0 from "./CodeMirror.vue?vue&type=style&index=0&id=ca3464e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports